import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const OcurrencesByGenderAnually = () => {
    const { chartData } = useProfileChartsDataContext();

    return (
        <SimpleBars
            title={'Resultado das ocorrências anuais por gênero'}
            horizontal={false}
            subtitles={chartData?.ocurrencesByGenderAnually?.categories}
            series={chartData?.ocurrencesByGenderAnually?.series}
            stacked
            customColors={['#FF4560','#008FFB', '#00E396']}
        />
    );
};